'use es6';

import { byName as TemplateTypes } from 'ContentUtils/constants/TemplateTypes';
import { FINDER_FILE_CREATE, FINDER_FILE_DELETE, FINDER_FILE_DUPLICATE, FINDER_FILE_DUPLICATE_LAYOUT_TO_TEMPLATE, FINDER_FILE_DUPLICATE_READ_ONLY, FINDER_FILE_RENAME, FINDER_FILE_RESTORE_DELETED, FINDER_FILES_BULK_DELETE, CUSTOM_WIDGET_BUFFER_FETCH, CUSTOM_WIDGET_BUFFER_FETCH_BY_PATH, GLOBAL_WIDGET_FETCH, TEMPLATE_BUFFER_FETCH, TEMPLATE_BUFFER_FETCH_BY_PATH, UNIFIED_LAYOUT_FETCH, LAYOUT_CELL_MAKE_GLOBAL, GLOBAL_WIDGET_UPGRADE, LAYOUT_WIDGET_MAKE_CMV2_GLOBAL, LAYOUT_WIDGET_MAKE_LOCAL_COPY_CMV2_GLOBAL_WIDGET, LAYOUT_WIDGET_RESTORE_PARENT, LAYOUT_REVERT, CUSTOM_WIDGET_REVERT, GLOBAL_WIDGET_REVERT, TEMPLATE_BUFFER_REVERT, RAW_ASSET_REVERT, FINDER_FOLDER_CONTENTS_MOVE } from 'DesignData/actions/ActionTypes';
import * as fileActions from 'DesignData/actions/finder/Files';
import * as layoutActions from 'DesignData/actions/UnifiedLayouts';
import * as customWidgetBuffersActions from 'DesignData/actions/CustomWidgetBuffers';
import * as customWidgetActions from 'DesignData/actions/CustomWidgets';
import * as templateBuffersActions from 'DesignData/actions/TemplateBuffers';
import * as globalWidgetActions from 'DesignData/actions/GlobalWidgets';
import { UnifiedLayout } from 'DesignData/models/layouts';
import { LAYOUT, CUSTOM_WIDGET, TEMPLATE, CSS as FOLDER_ASSET_TYPE_CSS, JS, GLOBAL_GROUP, GLOBAL_WIDGET } from 'DesignData/constants/FolderAssetTypes';
const assetTypes = [LAYOUT, CUSTOM_WIDGET, TEMPLATE, FOLDER_ASSET_TYPE_CSS, JS, GLOBAL_GROUP, GLOBAL_WIDGET];

function createDeletedAssetsMap(fileIdsByType, results) {
  return assetTypes.reduce((assetMap, assetType) => {
    const assetsAttempted = fileIdsByType[assetType];
    const deleteResults = results.reduce((acc, obj) => {
      acc[obj.id] = obj.succeeded;
      return acc;
    }, {});
    const assetsToDelete = assetsAttempted.reduce((acc, assetId) => {
      if (deleteResults[assetId]) {
        acc.push(assetId);
      }

      return acc;
    }, []);
    assetMap[assetType] = assetsToDelete;
    return assetMap;
  }, {});
}

function deleteAssets(fileType, fileIds) {
  switch (fileType) {
    case LAYOUT:
    case GLOBAL_GROUP:
      {
        return layoutActions.deleteLayouts(fileIds);
      }

    case TEMPLATE:
    case FOLDER_ASSET_TYPE_CSS:
    case JS:
      {
        return templateBuffersActions.deleteTemplates(fileIds);
      }

    case CUSTOM_WIDGET:
      {
        return customWidgetBuffersActions.deleteCustomWidgets(fileIds);
      }

    case GLOBAL_WIDGET:
      {
        return globalWidgetActions.deleteGlobalWidgets(fileIds);
      }

    default:
      return undefined;
  }
}

export default (({
  dispatch
}) => next => action => {
  const nextAction = next(action);

  switch (action.type) {
    case FINDER_FILE_CREATE:
    case FINDER_FILE_DUPLICATE:
    case FINDER_FILE_DUPLICATE_LAYOUT_TO_TEMPLATE:
    case FINDER_FILE_DUPLICATE_READ_ONLY:
    case FINDER_FILE_RESTORE_DELETED:
      {
        const {
          file,
          fileType
        } = action;

        if (file) {
          switch (fileType) {
            case LAYOUT:
            case GLOBAL_GROUP:
              {
                dispatch(layoutActions.createFromFile(file));
                break;
              }

            case CUSTOM_WIDGET:
              {
                dispatch(customWidgetActions.createFromFile(file));
                break;
              }

            case TEMPLATE:
            case FOLDER_ASSET_TYPE_CSS:
            case JS:
              {
                dispatch(templateBuffersActions.createFromFile(file));
                break;
              }

            case GLOBAL_WIDGET:
              {
                dispatch(globalWidgetActions.createFromFile(file));
                break;
              }

            default:
              break;
          }
        }

        break;
      }

    case FINDER_FILE_RENAME:
      {
        const {
          file,
          fileType
        } = action;

        if (file) {
          switch (fileType) {
            case LAYOUT:
            case GLOBAL_GROUP:
              {
                const layout = new UnifiedLayout(file);
                dispatch(layoutActions.moveOrRename(layout.id, layout));
                break;
              }

            case CUSTOM_WIDGET:
              {
                //  FINDER_FILE_RENAME taken care of in CustomWidgetBuffer reducer
                break;
              }

            case GLOBAL_WIDGET:
              {
                dispatch(globalWidgetActions.rename.receive(file.id, file));
                break;
              }

            case TEMPLATE:
            case FOLDER_ASSET_TYPE_CSS:
            case JS:
              {
                dispatch(templateBuffersActions.moveOrRenameFromFile(file.id, file));
                break;
              }

            default:
              break;
          }
        }

        break;
      }

    case FINDER_FILE_DELETE:
      {
        const {
          fileId,
          deleted,
          fileType
        } = action;

        if (fileId && fileType && deleted) {
          const deleteAction = deleteAssets(fileType, [fileId]);
          if (deleteAction) dispatch(deleteAction);
        }

        break;
      }

    case FINDER_FILES_BULK_DELETE:
      {
        const {
          fileIdsByType,
          results
        } = action;

        if (fileIdsByType && results) {
          const deletedAssetsMap = createDeletedAssetsMap(fileIdsByType, results);

          for (const assetType of assetTypes) {
            const assetsToDelete = deletedAssetsMap[assetType];

            if (assetsToDelete.length > 0) {
              dispatch(deleteAssets(assetType, assetsToDelete));
            }
          }
        }

        break;
      }

    case LAYOUT_CELL_MAKE_GLOBAL:
      {
        const {
          globalGroup
        } = action;

        if (globalGroup) {
          dispatch(fileActions.createFileFromEditor(globalGroup, GLOBAL_GROUP));
        }

        break;
      }

    case CUSTOM_WIDGET_BUFFER_FETCH:
    case CUSTOM_WIDGET_BUFFER_FETCH_BY_PATH:
    case LAYOUT_WIDGET_MAKE_CMV2_GLOBAL:
    case LAYOUT_WIDGET_MAKE_LOCAL_COPY_CMV2_GLOBAL_WIDGET:
    case GLOBAL_WIDGET_UPGRADE:
      {
        const {
          customWidget
        } = action;

        if (customWidget) {
          dispatch(fileActions.createFileFromEditor(customWidget, CUSTOM_WIDGET));
        }

        break;
      }

    case GLOBAL_WIDGET_FETCH:
      {
        const {
          globalWidget
        } = action;

        if (globalWidget) {
          dispatch(fileActions.createFileFromEditor(globalWidget, GLOBAL_WIDGET));
        }

        break;
      }

    case TEMPLATE_BUFFER_FETCH:
    case TEMPLATE_BUFFER_FETCH_BY_PATH:
      {
        const {
          template
        } = action;

        if (template && !template.generatedFromLayoutId) {
          const {
            templateType
          } = template;
          let fileType;

          if (templateType === TemplateTypes.css.id) {
            fileType = FOLDER_ASSET_TYPE_CSS;
          } else if (templateType === TemplateTypes.js.id) {
            fileType = JS;
          } else {
            fileType = TEMPLATE;
          }

          dispatch(fileActions.createFileFromEditor(template, fileType));
        }

        break;
      }

    case UNIFIED_LAYOUT_FETCH:
      {
        const {
          layout
        } = action;

        if (layout) {
          const isGlobalGroup = layout.templateType === TemplateTypes.global_group.id;
          const fileType = isGlobalGroup ? GLOBAL_GROUP : LAYOUT;
          dispatch(fileActions.createFileFromEditor(layout, fileType));
        }

        break;
      }

    case LAYOUT_REVERT:
      {
        const {
          layoutId,
          layout
        } = action;

        if (layout) {
          dispatch(fileActions.hideRevisions(layoutId));
        }

        break;
      }

    case CUSTOM_WIDGET_REVERT:
      {
        const {
          customWidgetId,
          customWidget
        } = action;

        if (customWidget) {
          dispatch(fileActions.hideRevisions(customWidgetId));
        }

        break;
      }

    case GLOBAL_WIDGET_REVERT:
      {
        const {
          globalWidgetId,
          globalWidget
        } = action;

        if (globalWidget) {
          dispatch(fileActions.hideRevisions(globalWidgetId));
        }

        break;
      }

    case TEMPLATE_BUFFER_REVERT:
      {
        const {
          templateId,
          template
        } = action;

        if (template) {
          dispatch(fileActions.hideRevisions(templateId));
        }

        break;
      }

    case RAW_ASSET_REVERT:
      {
        const {
          rawAssetId,
          rawAsset
        } = action;

        if (rawAsset) {
          dispatch(fileActions.hideRevisions(rawAssetId));
        }

        break;
      }

    case LAYOUT_WIDGET_RESTORE_PARENT:
      {
        const {
          widgetType,
          parent
        } = action;

        if (widgetType && parent) {
          let fileType;

          switch (widgetType) {
            case 'custom_widget':
              {
                fileType = CUSTOM_WIDGET;
                break;
              }

            case 'global_group':
              {
                fileType = GLOBAL_GROUP;
                break;
              }

            case 'global_widget':
              {
                fileType = GLOBAL_WIDGET;
                break;
              }

            default:
              {
                throw new Error(`Invalid widget parent type restored. Received '${widgetType}'.`);
              }
          }

          dispatch(fileActions.createFileFromEditor(parent, fileType));
        }

        break;
      }

    case FINDER_FOLDER_CONTENTS_MOVE:
      {
        const {
          contents
        } = action;

        if (contents) {
          contents.forEach(file => {
            const {
              id,
              type
            } = file;

            if (type === 'LAYOUT') {
              dispatch(layoutActions.updateLayoutFolder(id, file));
            }
          });
        }

        break;
      }

    default:
      break;
  }

  return nextAction;
});